import type { ListBoxItemProps as AriaListBoxItemProps } from "react-aria-components";
import { ListBoxItem as AriaListBoxItem } from "react-aria-components";
import { twMerge } from "tailwind-merge";
import { controlStyles } from "../../utils/controlStyles";
import { useSelectSize } from "../Select/Select";

/**
 * ListBoxItem
 *
 * A styled wrapper around `react-aria-components` ListBoxItem with size
 * variants that align with Edges typography.
 */
export interface ExtendedListBoxItemProps extends Omit<AriaListBoxItemProps, "className"> {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

export function ListBoxItem({ size, className, ...props }: ExtendedListBoxItemProps) {
  // Use context size from parent Select if no explicit size is provided
  const contextSize = useSelectSize();
  const effectiveSize = size ?? contextSize;

  const baseClassName =
    "flex cursor-default items-center gap-2 rounded-sm px-3 outline-none text-text-primary data-[focused]:bg-background-hover data-[focus-visible]:ring-2 data-[focus-visible]:ring-action-default data-[focus-visible]:ring-inset data-[selected]:bg-background-selected data-[selected]:font-medium overflow-hidden";

  return (
    <AriaListBoxItem
      {...props}
      className={twMerge(
        baseClassName,
        controlStyles[effectiveSize].paddingY,
        controlStyles[effectiveSize].text,
        className
      )}
    />
  );
}
